import{c as m}from"./chunk-AQQ67SAX.mjs";import"./chunk-MU4WOLM6.mjs";import{a,b as p}from"./chunk-VTRYZJDB.mjs";import{applyBoxStyles as c}from"@refract-ui/core";var l=Object.keys(a),x=(t,e)=>(t==null?void 0:t.withConfig)&&e?t.withConfig(e):t,i=(t,e,s,n,o={})=>{let r=(0,p.css)(...n),f=x(e,s),y=p.css`
    ${g=>c(g.theme.box,o)}
    ${r}
  `;return t?f`
      ${t}& {
        ${y}
      }
    `:f`${y}`},u=t=>{let e=s=>{let n=o=>{let r=typeof o.target=="string"?o.target:null;return(...f)=>i(r,a(o),s,f,t)};return n.withConfig=o=>e(o),n};return e()};for(let t of l){let e=n=>o=>(...r)=>i(t,a[t],n,r,o),s=e();s.withConfig=n=>e(n),u[t]=s}var T=u;export{m as SubTheme,T as default};
